/* eslint-disable no-unused-vars */
import { CONFIG_API } from "@/plugins/axios";

export function intervalParser(period = String()) {
  period = period.toLowerCase().trim();
  const parser = {
    monthly: "month",
    month: "monthly",
    weekly: "week",
    week: "weekly",
    daily: "day",
    day: "daily",
    hourly: "hour",
    hour: "hourly",
  };
  if (parser[period]) {
    return parser[period];
  }
  return "";
}

export const conversorFactor = {
  gwh: { gwh: 1, mwh: 10 ** 3, kwh: 10 ** 6, wh: 10 ** 9 },
  mwh: { gwh: 1 / 10 ** 3, mwh: 1, kwh: 10 ** 3, wh: 10 ** 6 },
  kwh: { gwh: 1 / 10 ** 6, mwh: 1 / 10 ** 3, kwh: 1, wh: 10 ** 3 },
};

export default class Goals {
  constructor(item) {
    Object.assign(this, item);
    this.values = [];
    this.data = [];
    this.multiplier = 1;
  }

  text() {
    return `${this.name} - ${this.description} (${this.eu}) `;
  }

  conversion(eu) {
    if (eu) {
      const baseEu = eu.toLowerCase();
      const goalEu = this.eu.toLowerCase();
      let multiplier = 1;
      if (conversorFactor[goalEu]) {
        multiplier = conversorFactor[goalEu][baseEu];
      }
      if (multiplier) {
        this.multiplier = multiplier;
        this.eu = eu;
      }
    }
  }

  async setData(params) {
    try {
      const res = await this.setValues(params);
      return res;
    } catch (error) {
      return error;
    }
  }

  async setValues(params) {
    try {
      if (Array.isArray(this.id)) {
        params.goals = this.id;
      } else {
        params.goals = [this.id];
      }
      this.values = await getGoalsValues(params);
      this.data = this.getDataset();
      return this.values;
    } catch (error) {
      console.error(error);
      return Promise.reject(error);
    }
    /**
     * Params: Interval, goals(ids), start, end
     * maybe is valid to replicate the same structure
     * used to historical measurements in goals, has a class that
     * deals with multiples instances of goals :)
     * good luck future lucas ;3
     */
  }

  label() {
    if (!this.eu) return this.description;
    return `${this.description} (${this.eu})`;
  }

  forEach(callback = (element, index, array) => {}) {
    for (let i = 0; i < this.values.length; i++) {
      const element = this.values[i];
      callback(element, i, this.values);
    }
  }

  dataset(decimalPlace = 2) {
    let values = this.getDataset((e) => ({
      x: e.timestamp,
      y: (e.value * this.multiplier).toFixed(decimalPlace),
    }));
    return values;
  }

  getEu() {
    return this.eu ? this.eu : "";
  }

  getDataset(callback) {
    let array = [];
    this.values.forEach((item) => {
      if (callback) {
        item = callback(item);
        if (item) array.push(item);
      } else {
        const { value, timestamp } = item;
        array.push({
          x: timestamp,
          y: value * this.multiplier,
        });
      }
    });
    return array;
  }
}

export class GoalsValues {
  constructor(item) {
    this.id = item.id;
    this.value = item.value;
    this.timestamp = item.timestamp;
    this.goals = item.goals;
  }
}

export async function getGoals(params = {}) {
  try {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers, params };
    let res = await CONFIG_API.get("goals/", config);
    if (params.page) {
      res.data.results = res.data.results.map((e) => new Goals(e));
      return res.data;
    }
    let data = res.data.map((goals) => new Goals(goals));
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function insertGoals(data) {
  try {
    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers };
    let res = await CONFIG_API.post("goals/", data, config);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function updateGoals(data) {
  try {
    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers };
    let res = await CONFIG_API.put(`goals/${data.id}/`, data, config);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteGoals(id) {
  try {
    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers };
    let res = await CONFIG_API.delete(`goals/${id}/`, config);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
}

function parseParams(params = {}) {
  const attributes = {
    start: "startTime",
    end: "endTime",
  };
  Object.keys(params).forEach((key) => {
    const newKey = attributes[key];
    if (newKey) {
      params[newKey] = params[key];
    }
  });
  return params;
}

async function getGoalsValues(params = {}) {
  try {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers, params: parseParams(params) };

    let res = await CONFIG_API.get("goals_values/", config);
    let data = res.data.map((e) => new GoalsValues(e));

    if (params.sum) {
      data = cummulativeSumGoal(data);
    }

    return data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function insertGoalsValues(params, data) {
  try {
    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers, params };
    let res = await CONFIG_API.post("goals_values/", data, config);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteGoalsValuesByYear(params = {}) {
  try {
    const headers = {
      "Content-Type": "application/json; charset=UTF-8",
      Authorization: "JWT " + localStorage.getItem("config_token"),
    };
    const config = { headers, params };
    let res = await CONFIG_API.delete("goals_values/delete_year/", config);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
}

export function cummulativeSumGoal(list, key = "value") {
  const set = new Set();
  list.forEach((element) => set.add(element.goals));
  set.forEach((goalsId) => {
    let sum = 0;
    list = list.map((item) => {
      if (goalsId == item.goals) {
        sum += item.value;
        item.value = sum;
      }
      return item;
    });
  });
  return list;
}
